<template>
  <v-card>
    <v-card-title>
      <v-autocomplete
        v-model="searchId"
        :items="$store.state.demandes.idsDemandes"
        hide-details
        hide-no-data
        hide-selected
        placeholder="ID demande"
        prepend-icon="mdi-pound"
        append-icon="mdi-magnify"
        @input="changeSearch('id')"
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-autocomplete
        v-model="searchEtat"
        :items="$store.state.demandes.etats"
        hide-details
        hide-no-data
        hide-selected
        item-text="libelle"
        item-value="valeur"
        placeholder="Etat"
        prepend-icon="mdi-tag-text"
        append-icon="mdi-magnify"
        @input="changeSearch('etat')"
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-autocomplete
        v-model="searchProduit"
        :items="$store.state.demandes.produitsDemandes"
        hide-details
        hide-no-data
        hide-selected
        item-text="denominationCommerciale"
        item-value="id"
        placeholder="Produit"
        prepend-icon="mdi-medical-bag"
        append-icon="mdi-magnify"
        @input="changeSearch('produit')"
      ></v-autocomplete>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="$store.state.demandes.pageEnCours"
      :loading="loading"
      :page.sync="pageIndex"
      :items-per-page.sync="perPage"
      :server-items-length="$store.state.demandes.nbTotal"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 15, 20],
      }"
      @update:page="pageUpdate"
      @update:items-per-page="itemsPerPageUpdate"
      disable-sort
      no-data-text="Aucune demande trouvée"
    >
      <template v-slot:[`item.etat`]="{ item }">
        <div class="text-center">
          <v-chip :color="getColor(item.etat)" dark>
            {{ item.etat }}
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getTypeIcon(item.type).color"
                v-bind="attrs"
                v-on="on"
                >{{ getTypeIcon(item.type).icon }}</v-icon
              >
            </template>
            <span>{{ item.type }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.idProduitOriginel`]="{ item }">
        {{ item.idProduitOriginel > 0 ? item.idProduitOriginel : "" }}
      </template>
      <template v-slot:[`item.dateCreation`]="{ item }">
        {{ item.dateCreation.substr(0, 10) }}
      </template>
      <template v-slot:[`item.reponse`]="{ item }">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="secondary"
                v-bind="attrs"
                v-on="on"
                v-if="item.reponse"
                >mdi-tooltip</v-icon
              >
            </template>
            <pre>{{ item.reponse }}</pre>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.dateReponsePharmat`]="{ item }">
        {{
          item.dateReponsePharmat ? item.dateReponsePharmat.substr(0, 10) : ""
        }}
      </template>
      <template v-slot:[`item.commands`]="{ item }">
        <v-row
          style="flex-wrap: nowrap"
          align="center"
          justify="space-around"
          v-if="
            item.etat.toLowerCase() == 'non transmise' ||
            item.etat.toLowerCase() == 'refusée' ||
            item.etat.toLowerCase() == 'a corriger'
          "
        >
          <v-btn
            icon
            color="info"
            :to="{ name: 'demande', params: { id: item.id } }"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            color="error"
            @click.stop="promptConfirmDeletion(item.id)"
          >
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </v-row>
        <v-row v-else>
          <v-btn
            icon
            color="info"
            :to="{ name: 'demande', params: { id: item.id } }"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="showDelConfirm" max-width="410">
      <v-card>
        <v-card-title class="text-h5">
          Confirmation de suppression
        </v-card-title>
        <v-card-text>
          Confirmez-vous la suppression de la demande #{{ deleteId }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="confirmDeletion"> Oui </v-btn>
          <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
      outlined
      bottom
      :color="delStatus"
    >
      <div v-if="delStatus == 'success'">Demande supprimée avec succès.</div>
      <div v-else>Echec de la suppression de la demande.</div>
      <template v-slot:action="{ attrs }">
        <v-btn :color="delStatus" text v-bind="attrs" @click="snackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";

export default {
  name: "DemandesListe",
  data() {
    return {
      perPage: 10,
      pageIndex: 1,
      searchProduit: 0,
      searchId: 0,
      searchEtat: 1,
      loading: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Produit", value: "produit" },
        { text: "(ID)", value: "idProduitOriginel" },
        { text: "Type", value: "type" },
        { text: "Date création", value: "dateCreation" },
        { text: "Etat", value: "etat", align: "center" },
        { text: "Réponse", value: "reponse" },
        { text: "Date", value: "dateReponsePharmat" },
        { text: " ", value: "commands" },
      ],
      showDelConfirm: false,
      deleteId: null,
      delStatus: "",
      snackbar: false,
    };
  },
  methods: {
    changeSearch(type) {
      switch (type) {
        case "id":
          this.searchEtat = 0;
          this.searchProduit = 0;
          break;
        case "etat":
          this.searchId = 0;
          this.searchProduit = 0;
          break;
        case "produit":
          this.searchId = 0;
          this.searchEtat = 0;
          break;
      }
      this.refreshDemandes(1, this.perPage);
    },
    promptConfirmDeletion(idDemande) {
      this.deleteId = idDemande;
      this.showDelConfirm = true;
    },
    async confirmDeletion() {
      await this.remove(this.deleteId);
      this.deleteId = null;
      this.showDelConfirm = false;
    },
    cancelDeletion() {
      this.deleteId = null;
      this.showDelConfirm = false;
    },
    remove(idDemande) {
      this.loading = true;
      FournisseurService.deleteDemande(idDemande)
        .then((res) => {
          if (res.status == 204) {
            this.delStatus = "success";
            this.refreshDemandes(this.pageIndex, this.perPage);
          }
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.loading = false;
          this.snackbar = true;
        });
    },
    pageUpdate(page) {
      this.refreshDemandes(page, this.perPage);
    },
    itemsPerPageUpdate(itemsPerPage) {
      this.refreshDemandes(this.pageIndex, itemsPerPage);
    },
    refreshDemandes(page, perPage) {
      this.loading = true;
      let options = { page, perPage };
      if (this.searchEtat != 0) {
        options.etat = this.searchEtat;
      }
      if (this.searchProduit != 0) {
        options.idProduit = this.searchProduit;
      }
      if (this.searchId != 0) {
        options.id = this.searchId;
      }
      FournisseurService.getDemandes(options)
        .then((res) => {
          let demandes = res.data;
          let totalDemandes = parseInt(res.headers["x-total-count"]);
          this.$store.dispatch("demandes/setPageDemandes", {
            demandes,
            totalDemandes,
          });
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            let demandes = [];
            let totalDemandes = 0;
            this.$store.dispatch("demandes/setPageDemandes", {
              demandes,
              totalDemandes,
            });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getColor(etat) {
      let etatLC = etat.toLowerCase();

      switch (etatLC) {
        case "en cours":
          return "warning";
        case "ok":
          return "success";
        case "refusée":
          return "error";
        case "non transmise":
          return "info";
      }
    },
    getTypeIcon(type) {
      let typeLC = type.toLowerCase();

      switch (typeLC) {
        case "création de produit par duplication":
          return { icon: "mdi-expand-all", color: "success" };
        case "création de produit":
          return { icon: "mdi-briefcase-plus", color: "success" };
        case "suppression d'un produit publié":
          return { icon: "mdi-briefcase-minus", color: "error" };
        case "modification d'un produit publié":
          return { icon: "mdi-briefcase-edit", color: "warning" };
      }
    },
  },
};
</script>

<style>
pre {
  font-family: Roboto, Helvetica, sans-serif;
}
</style>
